import { io } from 'socket.io-client'

const socket = io(process.env.REACT_APP_API_BASE_URL, {
  autoConnect: false
})


socket.onAny((event, ...args) => {
  console.log('[socket.onAny]', event, args)
})

socket.on('connect', () => {
  console.log('[socket.onConnect]')
})

socket.on('disconnect', (reason, details) => {
  console.log('[socket.onDisconnect]', reason, details)
})

export default socket
